<template>
  <div>
    <div class="mb-16 sm:mb-10 mt-10">
      <div
        class="flex sm:flex-col gap-8 justify-between grid grid-cols-3 sm:grid-cols-1"
      >
        <type-filter :type="filters.type" @set-type="setType" />

        <destination-filter
          :country="filters.country"
          :countries="countries"
          @set-destination="setDestination"
        />

        <date-filter :datetime="filters.datetime" @set-datetime="setDatetime" />
      </div>

      <category-filter
        :type="filters.type"
        :categories="filters.categories"
        @set-categories="setCategories"
      />
    </div>

    <template v-if="isFirstLoading">
      <ul class="list-reset row-tight">
        <li
          v-for="item in numberOfLoading()"
          :key="item"
          class="w-1/3 md:w-1/2 sm:w-full col-tight mb-8 sm:mb-5"
        >
          <loading-item />
        </li>
      </ul>
    </template>

    <div v-else-if="results.length">
      <result-section-liveaboard
        v-if="filters.type === 'liveaboard'"
        @show-more="loadMore"
        :datetime="filters.datetime"
        :page="page"
        :results="results"
        :filters="filters"
        :count="count"
        :isLoading="showMoreLoading"
      />

      <result-section-resort
        v-else
        @show-more="loadMore"
        :datetime="filters.datetime"
        :page="page"
        :results="results"
        :filters="filters"
        :count="count"
        :isLoading="showMoreLoading"
      />
    </div>

    <Empty v-else class="mt-10" />
  </div>
</template>

<script>
import axios from "axios";
import { ALL_COUNTRIES } from "../../helpers/collectionHelpers";
import { applyFilterURL } from "../../helpers/specialDealsHelpers";
import { getAlgoliaSuppliers } from "../../helpers/searchHelpers";
import LoadingItem from "../Collections/LoadingItem";
import Empty from "./Empty";
import DestinationFilter from "./DestinationFilter";
import DateFilter from "./DateFilter";
import TypeFilter from "./TypeFilter";
import CategoryFilter from "./CategoryFilter";
import ResultSectionLiveaboard from "./ResultSectionLiveaboard";
import ResultSectionResort from "./ResultSectionResort";

export default {
  components: {
    DestinationFilter,
    DateFilter,
    TypeFilter,
    ResultSectionLiveaboard,
    ResultSectionResort,
    Empty,
    LoadingItem,
    CategoryFilter,
  },
  data() {
    const searchParams = new URLSearchParams(window.location.search);
    let date = [];
    if (searchParams.has("from")) {
      date[0] = moment(searchParams.get("from"));
    }

    return {
      filters: {
        country: null,
        datetime: date,
        type: "liveaboard",
        categories: [],
      },
      countries: ALL_COUNTRIES,
      results: [],
      isFirstLoading: false,
      showMoreLoading: false,
      page: 1,
      count: 0,
    };
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has("categories")) {
      this.filters.categories = searchParams.get("categories").split(",");
    }

    if (searchParams.has("country")) {
      let country = searchParams.get("country");
      const selectedCountry = this.countries.find((_c) => _c.slug === country);
      this.filters.country = {
        label: selectedCountry.title,
        value: selectedCountry.slug,
        code: selectedCountry.code,
      };
    }

    if (searchParams.has("type")) {
      this.filters.type = searchParams.get("type");
    }

    this.loadSuppliers();
  },
  methods: {
    setDestination(val) {
      this.page = 1;
      if (val.value) {
        this.filters.country = val;
      } else {
        this.filters.country = null;
      }
      applyFilterURL(this.filters);
      this.loadSuppliers();
    },
    setDatetime(val) {
      this.page = 1;
      this.filters.datetime = val;
      applyFilterURL(this.filters);
      this.loadSuppliers();
    },
    setType(val) {
      this.page = 1;
      this.filters.type = val;
      this.filters.categories = [];
      applyFilterURL(this.filters);
      this.loadSuppliers();
    },
    setCategories(val) {
      this.page = 1;
      this.filters.categories = [val];
      applyFilterURL(this.filters);
      this.loadSuppliers();
    },
    buildUrl(dateFrom, dateTo, code, category, page) {
      const type = this.filters.type === "resort" ? "resorts" : "liveaboard";
      let template = "";
      const qs = new URLSearchParams({
        page: page,
        categories: category.join(","),
      }).toString();

      if (type === "resorts") {
        if (dateFrom && dateTo) {
          template = `:host/api/v1/:type/special_offers/:destinationCode/:dateFrom/:dateTo?${qs}`;
        } else {
          template = `:host/api/v1/:type/special_offers/:destinationCode?${qs}`;
        }
      } else {
        if (!dateFrom && !dateTo) {
          dateFrom = moment().format("YYYY-MM-DD");
          dateTo = moment().add(99, "years").format("YYYY-MM-DD");
        }

        template = `:host/api/v1/:type/special_offers/:destinationCode/:dateFrom/:dateTo?${qs}`;
      }

      return template
        .replace(":host", window.ZUBLU_VARIABLES.ODYSSEY_API)
        .replace(":type", type)
        .replace(":destinationCode", code)
        .replace(":dateFrom", dateFrom)
        .replace(":dateTo", dateTo);
    },
    loadSuppliers(isLoadmore = false) {
      const code = this.filters.country ? this.filters.country.code : "all";
      let dateFrom = null;
      let dateTo = null;

      if (this.filters.datetime[0]) {
        dateTo = moment(this.filters.datetime[0])
          .endOf("month")
          .format("YYYY-MM-DD");
        dateFrom = this.filters.datetime[0].format("YYYY-MM-DD");
      }

      const url = this.buildUrl(
        dateFrom,
        dateTo,
        code,
        this.filters.categories,
        this.page
      );

      if (isLoadmore) {
        this.showMoreLoading = true;
      } else {
        this.isFirstLoading = true;
      }

      axios
        .get(url)
        .then((response) => {
          const result = new Promise((resolve, reject) => {
            if (this.filters.type === "resort") {
              const supplierCraftIds = response.data.items.map(
                (s) => s.supplier_craft_id
              );
              getAlgoliaSuppliers(supplierCraftIds).then((result) => {
                response.data.items.forEach((_i) => {
                  result.hits.forEach((_h) => {
                    if (
                      _i.supplier_craft_id.toString() === _h.objectID.toString()
                    ) {
                      _i.supplier_gallery = _h.__platform_gallery;
                      _i.__platform_destination_title =
                        _h.__platform_destination_title;
                    }
                  });
                });
                resolve(response.data.items);
              });
            } else {
              resolve(response.data.items);
            }
          });

          result.then((rp) => {
            if (isLoadmore) {
              this.results = this.results.concat(rp);
            } else {
              this.results = rp;
            }

            this.isFirstLoading = false;
            this.showMoreLoading = false;
          });
          this.count = response.data.count;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    loadMore() {
      this.page += 1;
      this.loadSuppliers(true);
    },
    numberOfLoading() {
      const isDesktop = window.matchMedia(
        "only screen and (min-width: 1201px)"
      ).matches;
      const isTablet = window.matchMedia(
        "(min-width: 601px) and (max-width: 1200px)"
      ).matches;
      const isMobile = window.matchMedia("(max-width: 600px)").matches;

      if (isDesktop) return 9;
      else if (isTablet) return 6;
      else if (isMobile) return 3;
      return 9;
    },
  },
};
</script>

<style scoped>
.wrap-filter {
  grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 600px) {
  .wrap-filter {
    grid-template-columns: 1fr;
  }
}
</style>
